"use strict";
import "./components/config";
import "./components/header";
import "./components/lazy";
import "./components/animations";
import "./components/dropdown";
import "./components/tabs";
import "./components/modal";
import "./components/banner-video";
import "./components/faq-block";
import "./components/popup-video";
import "./components/popup-form";
import "./components/sliders";
import "./components/branch-slider";
